<template>
  <div class="app-cart" >
        <div class="app-cart">
          <h2 class="h3">
            <slot name="lblHeadline">Deine Kostenübersicht</slot>
          </h2>
          <table class="price-table cart--row">
            <caption class="sr-only"><slot name="captionPriceTable">Preise</slot></caption>
            <tbody>
            <tr class="price last-limited-price" aria-live="polite" aria-atomic="true">
              <td>
                <strong>
                  <slot name="lblPrice">Deine aktuelle Grundgebühr</slot>
                  <span class="small">&nbsp;<slot name="lblMonthly">(monatlich)</slot></span>
                </strong>
              </td>
              <td>
                <span class="new-price--amount">
                <strong>{{ priceWithoutEuro(selectedSim.productPrice) }}</strong>
              </span>
                &nbsp;
                <strong class="new-price--label">€
                </strong>
              </td>
            </tr>
          <tr class="cart--row last-limited-price">
            <td>
              <strong>
                <slot name="lblShippingCosts">Versandkosten</slot>
                <span class="small">&nbsp;<slot name="lblOnetime">(einmalig)</slot></span>
              </strong>
            </td>
            <td>
              <strong>0 &euro;</strong>
            </td>
          </tr>
            </tbody>
          </table>
          <div class="cart--row features" v-if="showFreeESIMMessage">
            <ul class="checklist">
              <slot name="listTariffHighlights"><li>Lorem, ipsum dolor.</li></slot>
            </ul>
          </div>
          <div class="cart--row infos">
            <strong>
              <slot name="lblTax">Alle Preise inkl. MwSt.</slot>
            </strong>
          </div>
        </div>
  </div>
</template>

<script>

import price from '@/mixins/formatters/price'
import formatDecimal from '@/mixins/formatters/formatDecimal'
import date from '@/mixins/validators/date'

export default {
  name: 'Cart',
  mixins: [
    price,
    formatDecimal,
    date
  ],
  data () {
    return {}
  },
  props: {
    showFreeESIMMessage: {
      type: Boolean,
      default: false
    }
  },
  methods: {},
  computed: {
    selectedSim () {
      return this.$store.getters['checkoutv2/substituteSim/selectedSim']
    }
  }
}
</script>
